<template>
  <!--自定义日期显示组件-->
  <div>
     {{date ? date : ''}}
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      date: null
    }
  },
  props: {
    record: Object, // 当前行的数据
    options: Array,
    vm: null, // 使用这个action的模型组件，可能为modelTable或modelTree，与callback中的vm用法保持一致
    title: String,
    modal: String
  },
  mounted () {
    this.getInit()
  },
  methods: {
    moment,
    async getInit () {
      if (!this.record.birthday) { return }
      this.date = moment(new Date(this.record.birthday)).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
